import React from "react";
import dayjs from "dayjs";
import localizedFormat from "dayjs/plugin/localizedFormat";
import get from "lodash/get";

dayjs.extend(localizedFormat);
const DateNoTime = ({ row, name, intl }) => {
  const value = get(row, name, "");
  const { locale } = intl || {};

  if (!value) {
    return null;
  }

  return <div>{dayjs(value).locale(locale).format("L")}</div>;
};

export default DateNoTime;
